(function() {
  function init() {
    var container = document.getElementById('delivery-badge-container');
    if (!container) return;

    var metafieldData = JSON.parse('{' + container.getAttribute('data-metafields') + '}');

    function updateDeliveryBadge(variantId) {
      var prenotabile = metafieldData[String(variantId)];
      if (prenotabile === true) {
        container.innerHTML = '<div class="delivery-badge delivery-badge--slow"><span class="delivery-badge__icon">📦</span><div class="delivery-badge__text"><strong>Disponibile in 7-8 giorni</strong><span>Il prodotto sarà pronto per la spedizione entro 7–8 giorni lavorativi.</span></div></div>';
      } else if (prenotabile === false) {
        container.innerHTML = '<div class="delivery-badge delivery-badge--fast"><span class="delivery-badge__icon">📦</span><div class="delivery-badge__text"><strong>Pronto in 2-3 giorni</strong><span>Il prodotto è già disponibile e sarà affidato al corriere entro 2-3 giorni lavorativi.</span></div></div>';
      } else {
        container.innerHTML = '';
      }
    }

    var currentVariantId = container.getAttribute('data-current-variant');
    updateDeliveryBadge(currentVariantId);

    new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        if (m.attributeName === 'data-variant-id') {
          var newVariantId = m.target.getAttribute('data-variant-id');
          if (newVariantId) updateDeliveryBadge(newVariantId);
        }
      });
    }).observe(document.body, {
      attributes: true,
      subtree: true,
      attributeFilter: ['data-variant-id']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
